module.exports = __webpack_public_path__ + "static/media/tick-blue-filled.cf8a86c8.svg";